import { routerCompat } from '@client/router/compat';

export const navigate = (path: string): void => {
  routerCompat.push(path);
};

export const goBack = (): void => {
  routerCompat.goBack();
};
